@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.loader {
  min-height: 400px;
}

.tax-identifier-form {
  width: 100%;
}
